/* eslint-disable */
import React, { useContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// d.ts
import { DCRecord } from '@/@types/lib/dataController';
import { IDataController } from '@/lib/DataController';

// Material UI Core

// Material UI Icons

// Custom Components
import ModelTable from '@/ui/Table/ModelTable';
import TableButtonEdit from '@/ui/Table/ActionButtons/TableButtonEdit';
import DialogContext from '@/context/DialogContext/DialogContext';
import LoaderContext from '@/context/LoaderContext/LoaderContext';
import UserTenantsDialog from './UserTenantsDialog';

import model from '@/models/user_tenant';

import dataController from '@/lib/DataController';
import { DialogContextType } from '@/context/DialogContext/DialogContext';
import { LoaderContextType } from '@/context/LoaderContext/LoaderContext';
import { useNavigate } from 'react-router-dom';
import UserContext from '@/context/UserContext/UserContext';

// TODO:
// subModels cleanup: they are added to the project because Table.jsx can not function without them
let asd = 0;
function UserTenantsTable() {
  const navigate = useNavigate();
  const dialogContext = useContext<DialogContextType>(DialogContext);
  const loaderContext = useContext(LoaderContext) as LoaderContextType;
  const userContext = useContext(UserContext)

  const { t } = useTranslation();

  const [records, setRecords] = useState<DCRecord[]>([]);

  const dc: IDataController = new dataController(model);

  useEffect(() => {
    if (userContext?.tenantId) {
      refreshRecords();
    }
  }, [userContext]);

  useEffect(() => {
    if (userContext?.tenantId) {
      refreshRecords();
    }
  }, []);

  const handleAdd = () => {
    dialogContext.showDialog(UserTenantsDialog, {
      dc: dc,
      mode: 'insert',
      form: 'insert',
      tenantId: userContext?.tenantId,
      onClose: handleDialogClose,
    });
  };

  const handleEdit = (
    evt: React.SyntheticEvent,
    sel: { [key: string]: DCRecord }
  ) => {
    const selId = Object.keys(sel)[0]; // neven check if works
    navigate('/user-tenants/' + sel[selId].id);
  };

  const handleDelete = (evt: React.SyntheticEvent, sel: string[]) => { };

  const handleDialogClose = (result: {
    dataChanged: boolean;
    action: string;
    id: number;
  }) => {
    if (result.dataChanged) {
      refreshRecords();
    }
    if (result.action === 'insert') {
      navigate(`/user-tenants/${result.id}`);
    }
  };

  const refreshRecords = () => {
    loaderContext.toggleLoading(true);
    dc.GetData("tenant-admin/tenants/" + userContext?.tenantId + '/users')
      .then((resp) => {
        if (resp.success) {
          if (Array.isArray(resp.data)) {
            setRecords(resp.data);
          } else {
            setRecords([]);
          }
        }
      })
      .finally(() => {
        loaderContext.toggleLoading(false);
      });
  };

  const fetchData = (limit: number, offset: number) => {
    for (let i = 0; i < limit; ++i) {
      records[offset * limit + i] = records[i % asd];
    }
    console.log('here', limit, offset);
    //@ts-ignore
    return new Promise((r) => r());
  };

  return (
    <ModelTable
      title={t('titles.users')}
      records={records}
      dc={dc}
      allowSelection="one"
      allowFilter={true}
      allowExport={true}
      allowAdd={true}
      allowColumnPicker={true}
      addLabel={t('buttons.new_m') as string}
      handleAdd={handleAdd}
      onRowAction={() => { }}
      allowRowAction={() => true}
      unselectRow={false}
      onDoubleClick={handleEdit}
    >
      <TableButtonEdit variant="contained" onClick={handleEdit} />
    </ModelTable>
  );
}

export default UserTenantsTable;
